module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/zeit/2b14ef21/src/components/Layout.js"},
    }]
